"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmountApp = void 0;
const unmountApp = async (appName) => {
    // First, unmount any components from the app if they exist
    if (typeof window !== 'undefined' && window[appName]) {
        // Preserve the init and get functions
        const initFunction = window[appName].init;
        const getFunction = window[appName].get;
        if (window[appName]) {
            if (typeof window[appName].unmount === 'function') {
                window[appName].unmount();
            }
            window[appName] = null;
            // Restore the init and get functions
            if (initFunction || getFunction) {
                window[appName] = {};
                if (initFunction)
                    window[appName].init = initFunction;
                if (getFunction)
                    window[appName].get = getFunction;
            }
        }
    }
    return true;
};
exports.unmountApp = unmountApp;
//# sourceMappingURL=unmount.js.map